<div class="cover-photo-container">
    <img decoding="async" src="/assets/srec-cover-photo-cropped.png" class="cover-photo"
        alt="Spruce-SREC-Cover-Photo" />
</div>
<div class="page-container">
    <div class="inner-page-container">
        <button class="form-back-button" mat-icon-button type="button" (click)="returnToRegisterSection()">
            <mat-icon>arrow_back</mat-icon>
        </button>

        <form-home-marketing-desk [showForm]="true" [referralSource]="referralSource" [isCommercial]="true">
        </form-home-marketing-desk>
    </div>
</div>